<ion-header mode="ios">
  <ion-toolbar>
    <ion-title>Reviews</ion-title>
    <ion-button slot="start" color="dark" fill="clear" (click)="closeModal()">Back</ion-button>
  </ion-toolbar>
</ion-header>
<ion-content>

  <div *ngIf="user" sxPadding="medium">

    <div sxPadding="medium">
      <div sxRow sxAlign="center" sxGap="10px" sxDistribution="start">
        <avatar-round [size]="50" [imageUrl]="user.displayPictureUrl" [title]="user.name"></avatar-round>
        <h2 sxTextSize="medium">{{user.name}}</h2>
      </div>

      <div sxRow sxAlign="center" sxGap="10px" sxDistribution="start" sxMargin="20px 0 10px">
        <ion-icon name="star" sxTextSize="24px"></ion-icon>
        <p sxMargin="0" >{{user?.averageRating?.toFixed(1)}} rating from {{user.totalReviews}} review</p>
      </div>

    </div>

    <div *ngIf="paginatedRatings" sxCol sxGap="10px">

      <div *ngFor="let rating of paginatedRatings.docs" sxPadding="medium" sxRadius="medium"
      sxBackground="light" sxBorderColor="one" sxBorderWidth="1px" sxWidth="full"
      [hidden]="rating.ratingDescription?.length < 1">

        <div sxRow sxAlign="center" sxDistribution="spaceBetween">
          <div sxRow sxGap="10px" sxAlign="center">
            <avatar-round [size]="30" [imageUrl]="rating?.ratedByAccount?.displayPictureUrl" [title]="rating?.ratedByAccount?.name"></avatar-round>
            <p sxMargin="0" sxTextWeight="normal" sxTextSize="medium">{{rating?.ratedByAccount?.name}}</p>
          </div>

          <div sxRow sxAlign="center" sxMargin="10px 0" sxGap="10px" sxColor="two">
            <ion-icon name="star-outline" sxTextSize="20px"></ion-icon>
            <p sxMargin="0">{{rating?.ratingNumber?.toFixed(1)}}</p>
          </div>
        </div>




        <p sxTextSize="small">{{rating?.ratingDescription}}</p>

        <p sxColor="two" sxTextSize="small">{{rating.createTime | date : 'dd MMM yyyy'}}</p>
      </div>

    </div>
  </div>



</ion-content>
